import { useMutation, useQueryClient, MutationOptions } from "react-query";
import { post, API_URL, APIResponse, APIError } from "../api";
import { CheckoutData } from "../@types";

export interface CommerceCheckoutPayload {
  cart_item_ids: string[];
  shipping_address: string;
  shipping_city: string;
  shipping_state: string;
  shipping_country: string;
  shipping_zip_code: string;
  notes?: string;
}

export function useCheckout(
  options?: MutationOptions<
    APIResponse<CheckoutData>,
    APIError,
    CommerceCheckoutPayload
  >
) {
  const queryClient = useQueryClient();

  const { mutate, isLoading, isError, error, data } = useMutation<
    APIResponse<CheckoutData>,
    APIError,
    CommerceCheckoutPayload
  >(
    (payload: CommerceCheckoutPayload) => {
      return post(`${API_URL}/commerce/cart/checkout`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries("cart");
        queryClient.invalidateQueries("customer-orders");
        options?.onSuccess?.(...args);
      },
    }
  );

  return {
    checkout: mutate,
    checkingOut: isLoading,
    isCheckoutError: isError,
    checkoutError: error,
    checkoutData: data,
  };
}
